module.exports = __webpack_public_path__ + "static/media/careerbuilder.03b56234.svg";